import styled from '@emotion/styled'
import { isMobile } from '@const/device'
import Subtitle from '@molecules/Subtitle'
import { Tag } from '@atoms/Text/styled'

export const LineWrapper = styled.div`
  display: flex;
  width: auto;
  min-width: 0;
`

const DesktopStyledSubtitle = styled(Subtitle)`
  font-size: ${({ theme }) => theme.text.h4.fontSize};
  line-height: ${({ theme }) => theme.text.h4.lineHeight};
  margin: 0 10px 0 0;
  display: flex;
  min-height: 24px;
  align-items: center;
  gap: 16px;

  > div:last-child {
    margin-left: 0;
  }
`
const MobileStyledSubtitle = styled(DesktopStyledSubtitle)`
  min-height: inherit;
`
export const StyledSubtitle = isMobile
  ? MobileStyledSubtitle
  : DesktopStyledSubtitle

const DesktopTitleText = styled.div`
  display: block;
  margin-right: 15px;
  max-width: 45vw;
  white-space: pre-wrap;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`
const MobileTitleText = styled(DesktopTitleText)`
  margin-right: 0;
  max-width: 100%;
`
export const TitleText = isMobile ? MobileTitleText : DesktopTitleText

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  width: 100%;
  min-width: 0;

  @media (max-width: 768px) {
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 8px;
  }
`

export const LeftWrapper = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`

export const HeaderWrapper = styled.div<{
  hovered: boolean
}>`
  background: ${({ theme }) => theme.colors.background.surface};
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
  flex-direction: ${() => (isMobile ? 'column' : 'row')};
  width: 100%;
  color: ${({
    hovered,
    theme: {
      colors: {
        text: { black, primary },
      },
    },
  }) => (hovered ? primary : black)};
  padding: ${() => (isMobile ? '0' : '20px 0')};
  flex-wrap: wrap;

  @media (max-width: 768px) {
    align-items: flex-start;
    flex-direction: column;
    padding: 0;
    margin: 10px 0;
  }
`

export const RightContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  width: ${() => (isMobile ? '100%' : 'auto')};
  min-width: 0;
  flex-shrink: 0;
  margin-top: ${() => (isMobile ? '12px' : '0')};
  margin-left: ${() => (isMobile ? '0' : '20px')};
  margin-right: 0;

  @media (max-width: 768px) {
    justify-content: space-between;
    gap: 20px;
    width: 100%;
    margin: 12px 0 0;
  }
`

export const StatusBadgeWrapper = styled.div`
  > div {
    margin: 0;
    width: fit-content;
    min-width: 0;
  }
`

export const DeletedStatus = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 40px;
  border-radius: 30px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: white;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  margin-right: ${() => (isMobile ? '0' : '35px')};
  margin-top: ${() => (isMobile ? '35px' : '0')};
  width: fit-content;
  min-width: 150px;
  padding: 0 20px;
  white-space: nowrap;
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.error};
`

export const HeaderArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 16px;
`

export const ChaptersCount = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const InfoRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
`

export const AvailabilityList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
`

// Строка «Компания • Филиал» — та же типографика тега, но чёрный цвет (по макету).
export const AvailabilityText = styled(Tag)`
  color: ${({ theme }) => theme.colors.text.black};
`
